import qs from 'qs';

export const IOS_EXIT_ADD_SHIFT_URI = 'syft://exitAddShift';
export const ANDROID_WEBVIEW_EXIT_URI = 'webview-exit';

const allowedEscapeUris = new Set([IOS_EXIT_ADD_SHIFT_URI, ANDROID_WEBVIEW_EXIT_URI]);

export const sanitizeEscapeUri = (escapeUri: string | undefined): string => {
    const trimmedEscapeUri = escapeUri?.trim() ?? '';

    return allowedEscapeUris.has(trimmedEscapeUri) ? trimmedEscapeUri : '';
};

export const buildEscapeUriWithQueryParams = (
    escapeUri: string,
    queryParams: Record<string, string | number | boolean | undefined>
): string => {
    const sanitizedEscapeUri = sanitizeEscapeUri(escapeUri);

    if (!sanitizedEscapeUri) {
        return '';
    }

    const serializedQueryParams = qs.stringify(queryParams);

    return serializedQueryParams ? `${sanitizedEscapeUri}?${serializedQueryParams}` : sanitizedEscapeUri;
};
